// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-color: #166E3F;
  --btn-hover:#1E874F;
  --font-color: #0C0D0E;
  --font-white: #fff;
  --font-benfit: #FAFAFA;
  --desc-color: #636363;
  --font-family: "Plus Jakarta Sans", sans-serif;
}

body {
  background-color: #FCFFE6;
}

html {
  scroll-behavior: smooth;
}

* {
  font-family: var(--font-family);
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

p {
  font-size: 18px !important;
  color: #000000b3 !important;
}

.container-navbar {
  z-index: 999;
  top: 30px;
  width: 100%;
  position: fixed;
  left: 0;
  right: 0;
}

navbar-content {
  transition: transform 0.4s;
}

.navbar-hidden {
  transform: translateY(-80px) !important;
}

header nav {
  display: flex;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  justify-content: space-between;
  align-items: center;
  width: 830px;
  border-radius: 32px;
  margin: 0 auto;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 18px !important;
  padding-right: 9px !important;
  position: relative;
}

.nav-list {
  display: flex;
}

nav .logo a {
  min-width: 48px;
  min-height: 48px;
}

nav .nav-list a {
  text-decoration: none;
  color: var(--desc-color);
  padding: 0 18px;
  min-width: 44px;
  min-height: 44px;
  font-weight: 500;
  font-size: 16px;
  display: inline-block;
  line-height: 44px;
}

nav .nav-list a:hover {
  color: var(--font-color);
}

nav .btn a {
  padding: 16px 24px;
  text-decoration: none;
  color: #fff;
  font-weight: 500;
  background-color: var(--primary-color);
  border-radius: 54px;
  font-size: 16px;
}

nav .btn a:hover {
  background-color: var(--primary-color);
  transition: all 0.2s ease-in;
}

.nav-link.active {
  color: var(--primary-color); 
  font-weight: bold;
}

nav .nav-list li {
  list-style: none;
}

.skip-link {
  position: absolute;
  height: 115px;
  top: -115px;
  left: 0;
  align-content: center;
  text-decoration: none;
  background-color: var(--primary-color);
  color: var(--color-text);
  padding: 44px;
  z-index: 10000000;
}

.skip-link:focus {
  top: 10px;
}

nav #hamburger {
  font-size: 32px;
  border: none;
  background-color: transparent;
  display: none;
}

.container-navbar {
  transition: transform 0.4s;
}

.navbar-hidden {
  transform: translateY(-110px) !important;
}

/* section diagnose */
.container-diagnose {
  display: flex;
  justify-content: center;
  /* gap: 100px; */
  max-width: 80rem;
  padding-top: 72px;
  margin: 32px auto 132px auto;
  position: relative;
}

.container-diagnose h1 {
  font-size: 2.5rem;
  color: var(--primary-color);
}

.btn-container {
  max-width: 80rem;
  margin: 0 auto;
  color: #fff;
}

.header-diagnose {
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
  padding: 24px 0;
  top: 0;
  left: 0;
  right: 0;
  padding-left: 4%;
  padding-right: 4%;
  position: fixed;
  z-index: 100000000;
  background-color: #fff;
}

.header-diagnose a {
  text-decoration: none;
  background-color: transparent;
  padding: 12px 24px;
  border-radius: 50px;
  font-weight: 500;
  color: var(--font-color);
  border: 1px solid #E8E8E8;
}

.header-diagnose .btn-container a:hover {
  background-color:rgb(245, 245, 245);
}

.upload-box {
  margin: 30px auto;
  box-sizing: border-box;
  background-color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  max-width: 80rem;
  padding: 16px;
  border-radius: 24px;
  border: 1px solid  #E8E8E8;
}

.upload-area {
  text-align: center;
  background-color: #ffffff;
  border: 2px dashed #dcdcdc;
  border-radius: 16px;
  padding: 100px 20px;
}

.upload-area img {
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
  border-radius: 16px;
}

.upload-area p {
  font-size: 1rem;
  color: #333;
  margin-bottom: 16px;
}

.upload-area a {
  color: #24702c;
  text-decoration: underline;
  cursor: pointer;
}

.tips-title {
  display: block;
  font-weight: 500;
  margin: 20px 0 10px;
}

.tips-list {
  list-style-type: disc;
  padding-left: 20px;
  font-size: 0.95rem;
  max-width: 400px;
  margin: 0 auto;
  text-align: left;
}

.tips-list li {
  padding: 4px;
  color: #9E9E9E;
}

.tips-title {
  margin-top: 40px;
  color: #9E9E9E;
}

#diagnose-btn {
  outline: none;
  background-color: #166E3F;
  color: #fff;
  padding: 14px 24px;
  border-radius: 50px;
  border: none;
  font-size: 16px;
}

#diagnose-btn:hover {
  cursor: pointer;
  background-color: var(--btn-hover);
  transition: all 0.2s ease-in;
}

.text-head {
  text-align: center;
}

.prediction-result h2{
color: var(--primary-color);
}

.prediction-result h3{
  margin-top: 18px;
  color: var(--primary-color);
}

.prediction-result p {
  padding-top: 8px;
  font-size: 18px;
  color: var(--font-color);  
  line-height: 24px;
  font-weight: 500;
}

.prediction-result ul {
  padding-top: 8px;
  list-style: none;
}

.prediction-result li {
  margin-bottom: 6px;
  padding-top: 8px;
  font-size: 18px;
  color: var(--font-color);  
  line-height: 24px;
  font-weight: 500;
}

/* section hero */
.hero-container {
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.hero-container svg {
  color: var(--primary-color);
  margin-left: 8px;
}

.hero-container .img-content {
  margin-top: 90px;
  margin-bottom: 80px;
}

.hero-container h1 {
  font-size: 62px;
  font-weight: 900;
  color: #166E3F;
}

.hero-container .text-wrapper {
  max-width: 46rem;
  margin-top: 154px;
}

.hero-container p {
  font-size: 18px;
  font-weight: 500;
  padding-top: 24px;
  line-height: 30px;
  color: var(--desc-text);
}

.hero-container .btn {
  margin-top: 64px;
}

.hero-container .btn a {
  padding: 20px 40px;
  text-decoration: none;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  background-color: var(--primary-color);
  border-radius: 50px;
  box-shadow: 0 10px 20px 2px #156e3f78;
}

.hero-container .btn a:hover {
  background-color: var(--btn-hover);
  transition: all 0.2s ease-in;
  box-shadow: none;
}

.hero-container img {
  width: 70%;
  height: 70%;
}

header {
  background-color: #E5F77E;
}

/* section fitur */
.container-fitur {
  max-width: 80rem;
  width: 100%;
  margin: 180px auto 0 auto;
}

.container-fitur .text-head {
  justify-content: center;
  text-align: center;
  max-width: 40rem;
}

.container-fitur .text-head h1 {
  font-size: 40px;
  color: var(--primary-color);
  font-weight: bold;
  margin-top: 24px;
}

.container-fitur p {
  font-size: 18px;
  color: #656565;
  font-weight: 500;
  padding-top: 16px;
  line-height: 28px;
}

.text-head span {
  border: 1.2px solid #166E3F;
  padding: 8px 20px;
  font-size: 18px;
  border-radius: 50px;
  color: #166E3F;
  font-weight: 500;
}

.container-fitur .content {
  display: flex;
  justify-content: center;
}

.grid-card {
  grid-column-gap: 24px;
  grid-row-gap: 24px;
  flex-wrap: wrap;
  grid-template-rows: auto;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-auto-columns: 1fr;
  display: grid;
  max-width: 80rem;
  margin: 56px auto 0 auto;
}

.item1 {
  grid-area: span 1 / span 7 / span 1 / span 7;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
}

.item2 {
  grid-area: span 1 / span 5 / span 1 / span 1;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
}

.item3 {
  grid-area: span 1 / span 5 / span 1 / span 5;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
}

.item4 {
  grid-area: span 1 / span 7 / span 1 / span 7;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
}

.grid-item {
  border-radius: 40px;
  padding: 32px;
  text-align: center;
}

.grid-item img {
  width: 100% !important;
  height: 100% !important;
}

.grid-item .text-content h2 {
  font-size: 24px;
  padding-top: 20px;
  font-weight: 600;
}

.grid-item .text-content p {
  font-size: 18px;
  color: #656565;
  line-height: 1.4;
  padding-top: 16px;
}

.grid-item .text-content {
  max-width: 34rem;
  text-align: left;
}

/* section testimonial*/
.container-testimonial {
  max-width: 80rem;
  /* background-color: #E5F77E; */
  width: 100%;
  margin: 0 auto;
}

.section-testimonial {
  margin-top: 180px;
}

.container-testimonial {
  padding: 0 4%;
}

.container-testimonial .img {
  margin-top: 24px;
}

.container-testimonial .content {
  display: flex;
  justify-content: center;
}

.container-testimonial h1 {
  font-size: 40px;
  font-weight: 900 !important;
  color: var( --primary-color);
  margin-top: -14px;
}

.container-testimonial p {
  font-size: 18px;
  color: #656565;
  font-weight: 500;
  padding-top: 16px;
  line-height: 28px;
}

.container-testimonial .text-head img {
  margin-bottom: 12px;
}

.container-testimonial .text-head {
  max-width: 40rem;
  text-align: center;
}

.card-testi-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-top: 54px;
  gap: 24px;
}

.card-testimonial {
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
  padding: 24px;
  border-radius: 16px;
}

.text-card p {
  font-size: 18px;
  line-height: 1.5;
  color: #656565;
}

.text-profile p {
  font-size: 14px;
  padding-top: 0px;
  color: #656565;
}

.text-profile p {
  font-size: 14px !important;
  color: #656565;
}

.card-testimonial h2 {
  font-size: 16px !important;
}

.card-testimonial .profile {
  margin-top: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
}


/* qna content*/
.qna-section {
  margin-top: 180px;
  padding: 0 4%;
}

.qna-section h1 {
  font-size: 40px;
  font-weight: 900 !important;
  color: var( --primary-color);
  margin-top: 24px;
}

.qna-section p {
  font-size: 18px;
  color: #656565;
  font-weight: 500;
  padding-top: 16px;
  line-height: 28px;
}

.qna-section .text-head {
  text-align: center;
}

.qna-section .main-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  max-width: 800px; 
  margin: 54px auto 0 auto; 
}

.content-item:hover {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px !important;
  transition: all 0.1s ease-in;
}

.content-item {
  background-color: #ffff;
  padding: 18px 20px !important;
}

.content-item.active svg {
  transform: rotate(180deg);
}

.content-item.active .answer {
  max-height: 300px;
}

.qna-section .question {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.qna-section .answer p {
  font-size: 16px;
  line-height: 1.6;
  padding-top: 12px;
}

.qna-section .answer {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s ease;
}

.qna-section .content-item {
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
  border-radius: 20px;
  padding: 0px 20px;
  cursor: pointer;
}

.qna-section svg {
  width: 32px;
}

/* gestarted section */
.getstarted-container {
  margin-top: 180px;
  padding: 0 4%;
  text-align: center;
  display: flex;
  justify-content: center;
  width: 100%;
}

.getstarted-container .text-head {
  justify-content: center;
  text-align: center;
  max-width: 34rem;
}

.getstarted-container h1 {
  font-size: 40px;
  font-weight: 900 !important;
  color: var( --primary-color);
  margin-top: 24px;
}

.getstarted-container p {
  font-size: 18px;
  color: #656565;
  font-weight: 500;
  padding-top: 16px;
  line-height: 28px;
}

.getstarted-container .btn {
  margin-top: 64px;
}

.getstarted-container .btn a {
  padding: 20px 40px;
  text-decoration: none;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  background-color: var(--primary-color);
  border-radius: 50px;
  box-shadow: 0 10px 20px 2px #156e3f78;
}

.getstarted-container a:hover {
  background-color: var(--btn-hover);
  transition: all 0.2s ease-in;
  box-shadow: none;
}

.getstarted-container svg {
  color: var(--primary-color);
  margin-left: 8px;
}

/* footer */
footer {
  padding-top: 72px;
  padding-bottom: 24px;
  margin: 180px auto 180px auto;
}

footer .copyright {
  text-align: center;
  margin-top: 72px;
}

.footer-container .main-content{
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
}

.footer-container {
  z-index: -9999;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 2fr));
  gap: 2rem;
  max-width: 1400px;     
  margin: 0 auto;         
  padding: 0 1rem;    
  align-items: start;
  flex-wrap: wrap;
}

footer p {
  font-size: 16px;
  padding-top: 14px;
  font-weight: 500;
  color: #656565;
}

.footer-container ul li {
  list-style: none;
}

.footer-container h2 {
  font-size: 18px;
  padding-bottom: 14px;
}

.img-full {
  width: 100%;
  position: relative;
}

.container-about{
  max-width: 80rem;
  width: 100%;
  margin: 180px auto 0 auto;
}

.container-about .text-head {
  justify-content: center;
  text-align: center;
  max-width: 40rem;
}

.container-about .text-head h1 {
  font-size: 40px;
  color: var(--primary-color);
  font-weight: bold;
  margin-top: 24px;
}

.container-about .content {
  display: flex;
  justify-content: center;
}

.container-about .main-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 64px;
  gap: 48px; /* tambahkan ini untuk jarak tetap */
  background-color: #fff;
  padding: 32px;
  border-radius: 40px;
}

.container-about .img-content img {
  width: 100%;
  height: auto;
  border-radius: 24px; /* opsional untuk visual lebih lembut */
  object-fit: cover;
}

.container-about .img-content {
  flex: 1;
  max-width: 50%;
}

.container-about .text-content {
  flex: 1;
  max-width: 50%;
}

.container-about .content-two {
  margin-top: 120px;
}

.container-about .content-two .text-content {
  max-width: 32rem;
}

.container-about .main-content {
  background-color: #fff;
  padding: 32px;
  border-radius: 40px;
}

.container-about .text-content {
  display: flex;
  flex-direction: column;
  max-width: 28rem;
}

.container-about .text-content h2 {
  font-size: 34px;
  color: var(--primary-color);
}

.container-about .text-content p {
  padding-top: 16px;
  font-size: 18px;
  font-weight: 500;
  padding-top: 24px;
  line-height: 30px;
  color: var(--desc-text);
}

.container-about .btn a {
  display: inline-block;
  padding: 20px 40px;
  text-decoration: none;
  color: #fff;
  margin-top: 32px;
  font-size: 18px;
  font-weight: 600;
  background-color: var(--primary-color);
  border-radius: 50px;
  box-shadow: 0 10px 20px 2px #156e3f78;
}

.container-about .btn a:hover {
  background-color: var(--btn-hover);
  transition: all 0.2s ease-in;
  box-shadow: none;
}

.alert-container {
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  border-radius: 12px;
  padding: 1rem 1.25rem;
  max-width: 60rem;
  margin: 110px auto 0 auto;
  font-family: system-ui, sans-serif;
  color: #333;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.alert-grid {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
}

.alert-icon-wrapper {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.alert-icon {
  width: 24px;
  height: 24px;
}

.alert-content {
  flex-grow: 1;
}

.alert-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.alert-heading {
  font-size: 1rem;
  font-weight: 600;
}

.alert-description {
  margin-top: 0.5rem;
  font-size: 0.92rem;
  line-height: 1.5;
}

.alert-description p {
  font-size: 16px !important;
  font-weight: 500;
  color: #333;
}

.alert-content h3 {
  font-size: 18px;
  color: #333;
  font-weight: 600;
}

.alert-close-btn {
  background: none;
  border: none;
  font-size: 1.1rem;
  color: #333;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,WAAW;EACX,eAAe;EACf,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,6BAA6B;EAC7B,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,OAAO;EACP,qBAAqB;EACrB,qBAAqB;EACrB,sCAAsC;EACtC,wBAAwB;EACxB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;AACA,2BAA2B;AAC3B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,sEAAsE;EACtE,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,4CAA4C;EAC5C,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,4CAA4C;EAC5C,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,4CAA4C;EAC5C,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,4CAA4C;EAC5C,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;;AAGA,eAAe;AACf;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,4DAA4D;EAC5D,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,+CAA+C;EAC/C,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,SAAS,EAAE,oCAAoC;EAC/C,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAE,uCAAuC;EAC5D,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;EAClC,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB","sourcesContent":[":root {\n  --primary-color: #166E3F;\n  --btn-hover:#1E874F;\n  --font-color: #0C0D0E;\n  --font-white: #fff;\n  --font-benfit: #FAFAFA;\n  --desc-color: #636363;\n  --font-family: \"Plus Jakarta Sans\", sans-serif;\n}\n\nbody {\n  background-color: #FCFFE6;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\n* {\n  font-family: var(--font-family);\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\np {\n  font-size: 18px !important;\n  color: #000000b3 !important;\n}\n\n.container-navbar {\n  z-index: 999;\n  top: 30px;\n  width: 100%;\n  position: fixed;\n  left: 0;\n  right: 0;\n}\n\nnavbar-content {\n  transition: transform 0.4s;\n}\n\n.navbar-hidden {\n  transform: translateY(-80px) !important;\n}\n\nheader nav {\n  display: flex;\n  background-color: #fff;\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;\n  justify-content: space-between;\n  align-items: center;\n  width: 830px;\n  border-radius: 32px;\n  margin: 0 auto;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  padding-left: 18px !important;\n  padding-right: 9px !important;\n  position: relative;\n}\n\n.nav-list {\n  display: flex;\n}\n\nnav .logo a {\n  min-width: 48px;\n  min-height: 48px;\n}\n\nnav .nav-list a {\n  text-decoration: none;\n  color: var(--desc-color);\n  padding: 0 18px;\n  min-width: 44px;\n  min-height: 44px;\n  font-weight: 500;\n  font-size: 16px;\n  display: inline-block;\n  line-height: 44px;\n}\n\nnav .nav-list a:hover {\n  color: var(--font-color);\n}\n\nnav .btn a {\n  padding: 16px 24px;\n  text-decoration: none;\n  color: #fff;\n  font-weight: 500;\n  background-color: var(--primary-color);\n  border-radius: 54px;\n  font-size: 16px;\n}\n\nnav .btn a:hover {\n  background-color: var(--primary-color);\n  transition: all 0.2s ease-in;\n}\n\n.nav-link.active {\n  color: var(--primary-color); \n  font-weight: bold;\n}\n\nnav .nav-list li {\n  list-style: none;\n}\n\n.skip-link {\n  position: absolute;\n  height: 115px;\n  top: -115px;\n  left: 0;\n  align-content: center;\n  text-decoration: none;\n  background-color: var(--primary-color);\n  color: var(--color-text);\n  padding: 44px;\n  z-index: 10000000;\n}\n\n.skip-link:focus {\n  top: 10px;\n}\n\nnav #hamburger {\n  font-size: 32px;\n  border: none;\n  background-color: transparent;\n  display: none;\n}\n\n.container-navbar {\n  transition: transform 0.4s;\n}\n\n.navbar-hidden {\n  transform: translateY(-110px) !important;\n}\n\n/* section diagnose */\n.container-diagnose {\n  display: flex;\n  justify-content: center;\n  /* gap: 100px; */\n  max-width: 80rem;\n  padding-top: 72px;\n  margin: 32px auto 132px auto;\n  position: relative;\n}\n\n.container-diagnose h1 {\n  font-size: 2.5rem;\n  color: var(--primary-color);\n}\n\n.btn-container {\n  max-width: 80rem;\n  margin: 0 auto;\n  color: #fff;\n}\n\n.header-diagnose {\n  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;\n  padding: 24px 0;\n  top: 0;\n  left: 0;\n  right: 0;\n  padding-left: 4%;\n  padding-right: 4%;\n  position: fixed;\n  z-index: 100000000;\n  background-color: #fff;\n}\n\n.header-diagnose a {\n  text-decoration: none;\n  background-color: transparent;\n  padding: 12px 24px;\n  border-radius: 50px;\n  font-weight: 500;\n  color: var(--font-color);\n  border: 1px solid #E8E8E8;\n}\n\n.header-diagnose .btn-container a:hover {\n  background-color:rgb(245, 245, 245);\n}\n\n.upload-box {\n  margin: 30px auto;\n  box-sizing: border-box;\n  background-color: #ffffff;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);\n  max-width: 80rem;\n  padding: 16px;\n  border-radius: 24px;\n  border: 1px solid  #E8E8E8;\n}\n\n.upload-area {\n  text-align: center;\n  background-color: #ffffff;\n  border: 2px dashed #dcdcdc;\n  border-radius: 16px;\n  padding: 100px 20px;\n}\n\n.upload-area img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: cover;\n  border-radius: 16px;\n}\n\n.upload-area p {\n  font-size: 1rem;\n  color: #333;\n  margin-bottom: 16px;\n}\n\n.upload-area a {\n  color: #24702c;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.tips-title {\n  display: block;\n  font-weight: 500;\n  margin: 20px 0 10px;\n}\n\n.tips-list {\n  list-style-type: disc;\n  padding-left: 20px;\n  font-size: 0.95rem;\n  max-width: 400px;\n  margin: 0 auto;\n  text-align: left;\n}\n\n.tips-list li {\n  padding: 4px;\n  color: #9E9E9E;\n}\n\n.tips-title {\n  margin-top: 40px;\n  color: #9E9E9E;\n}\n\n#diagnose-btn {\n  outline: none;\n  background-color: #166E3F;\n  color: #fff;\n  padding: 14px 24px;\n  border-radius: 50px;\n  border: none;\n  font-size: 16px;\n}\n\n#diagnose-btn:hover {\n  cursor: pointer;\n  background-color: var(--btn-hover);\n  transition: all 0.2s ease-in;\n}\n\n.text-head {\n  text-align: center;\n}\n\n.prediction-result h2{\ncolor: var(--primary-color);\n}\n\n.prediction-result h3{\n  margin-top: 18px;\n  color: var(--primary-color);\n}\n\n.prediction-result p {\n  padding-top: 8px;\n  font-size: 18px;\n  color: var(--font-color);  \n  line-height: 24px;\n  font-weight: 500;\n}\n\n.prediction-result ul {\n  padding-top: 8px;\n  list-style: none;\n}\n\n.prediction-result li {\n  margin-bottom: 6px;\n  padding-top: 8px;\n  font-size: 18px;\n  color: var(--font-color);  \n  line-height: 24px;\n  font-weight: 500;\n}\n\n/* section hero */\n.hero-container {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n}\n\n.hero-container svg {\n  color: var(--primary-color);\n  margin-left: 8px;\n}\n\n.hero-container .img-content {\n  margin-top: 90px;\n  margin-bottom: 80px;\n}\n\n.hero-container h1 {\n  font-size: 62px;\n  font-weight: 900;\n  color: #166E3F;\n}\n\n.hero-container .text-wrapper {\n  max-width: 46rem;\n  margin-top: 154px;\n}\n\n.hero-container p {\n  font-size: 18px;\n  font-weight: 500;\n  padding-top: 24px;\n  line-height: 30px;\n  color: var(--desc-text);\n}\n\n.hero-container .btn {\n  margin-top: 64px;\n}\n\n.hero-container .btn a {\n  padding: 20px 40px;\n  text-decoration: none;\n  color: #fff;\n  font-size: 18px;\n  font-weight: 600;\n  background-color: var(--primary-color);\n  border-radius: 50px;\n  box-shadow: 0 10px 20px 2px #156e3f78;\n}\n\n.hero-container .btn a:hover {\n  background-color: var(--btn-hover);\n  transition: all 0.2s ease-in;\n  box-shadow: none;\n}\n\n.hero-container img {\n  width: 70%;\n  height: 70%;\n}\n\nheader {\n  background-color: #E5F77E;\n}\n\n/* section fitur */\n.container-fitur {\n  max-width: 80rem;\n  width: 100%;\n  margin: 180px auto 0 auto;\n}\n\n.container-fitur .text-head {\n  justify-content: center;\n  text-align: center;\n  max-width: 40rem;\n}\n\n.container-fitur .text-head h1 {\n  font-size: 40px;\n  color: var(--primary-color);\n  font-weight: bold;\n  margin-top: 24px;\n}\n\n.container-fitur p {\n  font-size: 18px;\n  color: #656565;\n  font-weight: 500;\n  padding-top: 16px;\n  line-height: 28px;\n}\n\n.text-head span {\n  border: 1.2px solid #166E3F;\n  padding: 8px 20px;\n  font-size: 18px;\n  border-radius: 50px;\n  color: #166E3F;\n  font-weight: 500;\n}\n\n.container-fitur .content {\n  display: flex;\n  justify-content: center;\n}\n\n.grid-card {\n  grid-column-gap: 24px;\n  grid-row-gap: 24px;\n  flex-wrap: wrap;\n  grid-template-rows: auto;\n  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;\n  grid-auto-columns: 1fr;\n  display: grid;\n  max-width: 80rem;\n  margin: 56px auto 0 auto;\n}\n\n.item1 {\n  grid-area: span 1 / span 7 / span 1 / span 7;\n  background-color: #fff;\n  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;\n}\n\n.item2 {\n  grid-area: span 1 / span 5 / span 1 / span 1;\n  background-color: #fff;\n  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;\n}\n\n.item3 {\n  grid-area: span 1 / span 5 / span 1 / span 5;\n  background-color: #fff;\n  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;\n}\n\n.item4 {\n  grid-area: span 1 / span 7 / span 1 / span 7;\n  background-color: #fff;\n  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;\n}\n\n.grid-item {\n  border-radius: 40px;\n  padding: 32px;\n  text-align: center;\n}\n\n.grid-item img {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.grid-item .text-content h2 {\n  font-size: 24px;\n  padding-top: 20px;\n  font-weight: 600;\n}\n\n.grid-item .text-content p {\n  font-size: 18px;\n  color: #656565;\n  line-height: 1.4;\n  padding-top: 16px;\n}\n\n.grid-item .text-content {\n  max-width: 34rem;\n  text-align: left;\n}\n\n/* section testimonial*/\n.container-testimonial {\n  max-width: 80rem;\n  /* background-color: #E5F77E; */\n  width: 100%;\n  margin: 0 auto;\n}\n\n.section-testimonial {\n  margin-top: 180px;\n}\n\n.container-testimonial {\n  padding: 0 4%;\n}\n\n.container-testimonial .img {\n  margin-top: 24px;\n}\n\n.container-testimonial .content {\n  display: flex;\n  justify-content: center;\n}\n\n.container-testimonial h1 {\n  font-size: 40px;\n  font-weight: 900 !important;\n  color: var( --primary-color);\n  margin-top: -14px;\n}\n\n.container-testimonial p {\n  font-size: 18px;\n  color: #656565;\n  font-weight: 500;\n  padding-top: 16px;\n  line-height: 28px;\n}\n\n.container-testimonial .text-head img {\n  margin-bottom: 12px;\n}\n\n.container-testimonial .text-head {\n  max-width: 40rem;\n  text-align: center;\n}\n\n.card-testi-container {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  margin-top: 54px;\n  gap: 24px;\n}\n\n.card-testimonial {\n  background-color: #fff;\n  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;\n  padding: 24px;\n  border-radius: 16px;\n}\n\n.text-card p {\n  font-size: 18px;\n  line-height: 1.5;\n  color: #656565;\n}\n\n.text-profile p {\n  font-size: 14px;\n  padding-top: 0px;\n  color: #656565;\n}\n\n.text-profile p {\n  font-size: 14px !important;\n  color: #656565;\n}\n\n.card-testimonial h2 {\n  font-size: 16px !important;\n}\n\n.card-testimonial .profile {\n  margin-top: 24px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n\n/* qna content*/\n.qna-section {\n  margin-top: 180px;\n  padding: 0 4%;\n}\n\n.qna-section h1 {\n  font-size: 40px;\n  font-weight: 900 !important;\n  color: var( --primary-color);\n  margin-top: 24px;\n}\n\n.qna-section p {\n  font-size: 18px;\n  color: #656565;\n  font-weight: 500;\n  padding-top: 16px;\n  line-height: 28px;\n}\n\n.qna-section .text-head {\n  text-align: center;\n}\n\n.qna-section .main-content {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  align-items: center;\n  max-width: 800px; \n  margin: 54px auto 0 auto; \n}\n\n.content-item:hover {\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px !important;\n  transition: all 0.1s ease-in;\n}\n\n.content-item {\n  background-color: #ffff;\n  padding: 18px 20px !important;\n}\n\n.content-item.active svg {\n  transform: rotate(180deg);\n}\n\n.content-item.active .answer {\n  max-height: 300px;\n}\n\n.qna-section .question {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.qna-section .answer p {\n  font-size: 16px;\n  line-height: 1.6;\n  padding-top: 12px;\n}\n\n.qna-section .answer {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.4s ease;\n}\n\n.qna-section .content-item {\n  background-color: #fff;\n  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;\n  border-radius: 20px;\n  padding: 0px 20px;\n  cursor: pointer;\n}\n\n.qna-section svg {\n  width: 32px;\n}\n\n/* gestarted section */\n.getstarted-container {\n  margin-top: 180px;\n  padding: 0 4%;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.getstarted-container .text-head {\n  justify-content: center;\n  text-align: center;\n  max-width: 34rem;\n}\n\n.getstarted-container h1 {\n  font-size: 40px;\n  font-weight: 900 !important;\n  color: var( --primary-color);\n  margin-top: 24px;\n}\n\n.getstarted-container p {\n  font-size: 18px;\n  color: #656565;\n  font-weight: 500;\n  padding-top: 16px;\n  line-height: 28px;\n}\n\n.getstarted-container .btn {\n  margin-top: 64px;\n}\n\n.getstarted-container .btn a {\n  padding: 20px 40px;\n  text-decoration: none;\n  color: #fff;\n  font-size: 18px;\n  font-weight: 600;\n  background-color: var(--primary-color);\n  border-radius: 50px;\n  box-shadow: 0 10px 20px 2px #156e3f78;\n}\n\n.getstarted-container a:hover {\n  background-color: var(--btn-hover);\n  transition: all 0.2s ease-in;\n  box-shadow: none;\n}\n\n.getstarted-container svg {\n  color: var(--primary-color);\n  margin-left: 8px;\n}\n\n/* footer */\nfooter {\n  padding-top: 72px;\n  padding-bottom: 24px;\n  margin: 180px auto 180px auto;\n}\n\nfooter .copyright {\n  text-align: center;\n  margin-top: 72px;\n}\n\n.footer-container .main-content{\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1.5rem;\n}\n\n.footer-container {\n  z-index: -9999;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 2fr));\n  gap: 2rem;\n  max-width: 1400px;     \n  margin: 0 auto;         \n  padding: 0 1rem;    \n  align-items: start;\n  flex-wrap: wrap;\n}\n\nfooter p {\n  font-size: 16px;\n  padding-top: 14px;\n  font-weight: 500;\n  color: #656565;\n}\n\n.footer-container ul li {\n  list-style: none;\n}\n\n.footer-container h2 {\n  font-size: 18px;\n  padding-bottom: 14px;\n}\n\n.img-full {\n  width: 100%;\n  position: relative;\n}\n\n.container-about{\n  max-width: 80rem;\n  width: 100%;\n  margin: 180px auto 0 auto;\n}\n\n.container-about .text-head {\n  justify-content: center;\n  text-align: center;\n  max-width: 40rem;\n}\n\n.container-about .text-head h1 {\n  font-size: 40px;\n  color: var(--primary-color);\n  font-weight: bold;\n  margin-top: 24px;\n}\n\n.container-about .content {\n  display: flex;\n  justify-content: center;\n}\n\n.container-about .main-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 64px;\n  gap: 48px; /* tambahkan ini untuk jarak tetap */\n  background-color: #fff;\n  padding: 32px;\n  border-radius: 40px;\n}\n\n.container-about .img-content img {\n  width: 100%;\n  height: auto;\n  border-radius: 24px; /* opsional untuk visual lebih lembut */\n  object-fit: cover;\n}\n\n.container-about .img-content {\n  flex: 1;\n  max-width: 50%;\n}\n\n.container-about .text-content {\n  flex: 1;\n  max-width: 50%;\n}\n\n.container-about .content-two {\n  margin-top: 120px;\n}\n\n.container-about .content-two .text-content {\n  max-width: 32rem;\n}\n\n.container-about .main-content {\n  background-color: #fff;\n  padding: 32px;\n  border-radius: 40px;\n}\n\n.container-about .text-content {\n  display: flex;\n  flex-direction: column;\n  max-width: 28rem;\n}\n\n.container-about .text-content h2 {\n  font-size: 34px;\n  color: var(--primary-color);\n}\n\n.container-about .text-content p {\n  padding-top: 16px;\n  font-size: 18px;\n  font-weight: 500;\n  padding-top: 24px;\n  line-height: 30px;\n  color: var(--desc-text);\n}\n\n.container-about .btn a {\n  display: inline-block;\n  padding: 20px 40px;\n  text-decoration: none;\n  color: #fff;\n  margin-top: 32px;\n  font-size: 18px;\n  font-weight: 600;\n  background-color: var(--primary-color);\n  border-radius: 50px;\n  box-shadow: 0 10px 20px 2px #156e3f78;\n}\n\n.container-about .btn a:hover {\n  background-color: var(--btn-hover);\n  transition: all 0.2s ease-in;\n  box-shadow: none;\n}\n\n.alert-container {\n  background-color: #fff3cd;\n  border: 1px solid #ffeeba;\n  border-radius: 12px;\n  padding: 1rem 1.25rem;\n  max-width: 60rem;\n  margin: 110px auto 0 auto;\n  font-family: system-ui, sans-serif;\n  color: #333;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n}\n\n.alert-grid {\n  display: flex;\n  gap: 1rem;\n  align-items: flex-start;\n}\n\n.alert-icon-wrapper {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.alert-icon {\n  width: 24px;\n  height: 24px;\n}\n\n.alert-content {\n  flex-grow: 1;\n}\n\n.alert-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.alert-heading {\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.alert-description {\n  margin-top: 0.5rem;\n  font-size: 0.92rem;\n  line-height: 1.5;\n}\n\n.alert-description p {\n  font-size: 16px !important;\n  font-weight: 500;\n  color: #333;\n}\n\n.alert-content h3 {\n  font-size: 18px;\n  color: #333;\n  font-weight: 600;\n}\n\n.alert-close-btn {\n  background: none;\n  border: none;\n  font-size: 1.1rem;\n  color: #333;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
